import React from 'react';
import classnames from 'classnames';
import ImageIcon from '@wix/da-ds/pkg/Icons/32x32/AddImage';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import { MAX_WIDTH_FOR_TOOLTIP } from './constants';
import s from './Unknown.scss';
const UnknownDumbView = ({ width, height, className, 'aria-hidden': ariaHidden })=>{
    const { t } = useTranslation();
    return width && width > MAX_WIDTH_FOR_TOOLTIP ? /*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames(className, s['root']),
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(ImageIcon, {
        size: IconSize.BIG,
        className: s['imageicon']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['nopreview']
    }, t('deviationview.unknown.nopreview'))) : /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
        tooltipText: t('deviationview.unknown.nopreview')
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames(className, s['root']),
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(ImageIcon, {
        size: IconSize.BIG,
        className: s['imageicon']
    }))));
};
export default UnknownDumbView;
